export default "__VITE_ASSET__8e84d881__"